import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Lock } from "lucide-react";

export const ChangePasswordModal = () => {
  const { changePassword, user } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }

    setSaving(true);
    try {
      await changePassword(password);
      toast.success("Password changed successfully!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-stone-900/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-8">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-amber-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-amber-600" strokeWidth={1.5} />
          </div>
          <h2 className="font-heading font-bold text-xl text-stone-800">Set New Password</h2>
          <p className="text-sm text-stone-500 mt-1">
            Welcome, {user?.name}. Please set a new password to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Input
              type="password"
              placeholder="New password (min 6 characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              required
              data-testid="new-password-input"
              className="h-12"
            />
          </div>
          <div>
            <Input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={6}
              required
              data-testid="confirm-password-input"
              className="h-12"
            />
          </div>
          <Button
            type="submit"
            disabled={saving || password.length < 6 || password !== confirm}
            data-testid="change-password-btn"
            className="w-full bg-primary hover:bg-primary/90 text-white rounded-xl h-12 text-base"
          >
            {saving ? "Saving..." : "Set Password & Continue"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
